import { Typography, Space, Tag } from "antd";
import { CheckCircleOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

const { Text } = Typography;

const DoctorPayments = () => {
  const { t } = useTranslation();
  const isEmpty = false;

  return (
    <Space direction="vertical" size={8}>
      <Text strong style={{ fontSize: 22, lineHeight: 1 }}>{t("settingsPage.payment.invoicesTitle")}</Text>
      <Space direction="vertical" size={4}>
        {!isEmpty ? (
          <>
            <Space size={32} style={{ padding: "16px 0" }}>
              <Text type="secondary">19 Mag 2024</Text>
              <Text type="secondary">20,00€</Text>
              <Tag icon={<CheckCircleOutlined />} color="success" style={{ marginRight: 0 }}>Pagata</Tag>
              <Text type="secondary">Visita del 18 Maggio 2024</Text>
            </Space>
            <Space size={32} style={{ padding: "16px 0" }}>
              <Text type="secondary">19 Mag 2024</Text>
              <Text type="secondary">20,00€</Text>
              <Tag icon={<CheckCircleOutlined />} color="warning" style={{ marginRight: 0 }}>In lavorazione</Tag>
              <Text type="secondary">Visita del 16 Maggio 2024</Text>
            </Space>
            <Space size={32} style={{ padding: "16px 0" }}>
              <Text type="secondary">15 Mag 2024</Text>
              <Text type="secondary">20,00€</Text>
              <Tag icon={<CheckCircleOutlined />} color="warning" style={{ marginRight: 0 }}>Visita del 16 Maggio 2024</Tag>
              <Text type="secondary">Visita del 16 Maggio 2024</Text>
            </Space>
          </>
        ) : (<Text>no payment yet</Text>)}
      </Space>
    </Space>
  );
};

export default DoctorPayments;
